import { memo } from 'react';

interface IIconSettingsProps {
  className?: string;
}

export const IconSettings = memo(({ className }: IIconSettingsProps) => (
  <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11" cy="12" r="2" stroke="currentColor" strokeWidth="2" fill="none" />
    <rect x="15" y="11" width="7" height="2" fill="currentColor" />

    <rect x="9" y="19" width="7" height="2" fill="currentColor" />
    <circle cx="20" cy="20" r="2" stroke="currentColor" strokeWidth="2" fill="none" />
  </svg>
));
